import React, { useState } from 'react'
import { Card, Button, CardTitle, CardText, CardImg, CardBody, CardLink, CardSubtitle, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ModalForm from './Form';
export default function Checkout() {
    const [modal, setModal] = useState(false);
    const toggle = () => {
        setModal(!modal)
    };
    return (
        <div>
            <Card body inverse style={{ backgroundColor: '#333', borderColor: '#333', textAlign: 'center', fontSize: 'large' }}>
                <CardSubtitle>ROLEX</CardSubtitle>
                <CardTitle>Yacht-Master</CardTitle>
                <CardText>
                    Manufacturer number: 16628
                    <br />
                    Product number: 2106235
                    <br />
                    <br />
                    <Badge onDoubleClick={() => { toggle(); }} className="price" style={{ padding: '17px 50px', marginBottom: '8px' }} color="light">
                        <var style={{ fontSize: '24px' }} ><abbr >€</abbr> 25,150<sup>*</sup></var>
                    </Badge>
                    <p>*Prices incl. VAT</p>
                </CardText>
                <Button style={{ fontSize: '20px' }} className="btn-outline-dark salesDeskBtn checkout" >Submit</Button>
            </Card>
            <Modal
                centered={true}
                isOpen={modal}
                toggle={toggle}
            >
                <ModalHeader toggle={toggle}>Discount</ModalHeader>
                <ModalBody>
                    <ModalForm />
                </ModalBody>
            </Modal>
        </div>
    )
}
